module.exports = __webpack_public_path__ + "static/ganbari-abc9036ed25b24c27c70eb70195f3989.jpg";